// extracted by mini-css-extract-plugin
export default {"button":"VersionForward_button__9CUU4","image":"VersionForward_image__Bh4Jv"};